import { FadeIn } from "./FadeIn";
import { EXPERIENCE } from "@/content";

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="bg-[#0A0F16] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto max-w-5xl">
      <FadeIn>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#D18237]">{EXPERIENCE.overline}</p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-[#F6F5F2] md:text-5xl">{EXPERIENCE.title}</h2>
      </FadeIn>
      <div className="mt-16">
        {EXPERIENCE.roles.map((r, i) => (
          <FadeIn key={i} delay={i * 0.05}>
            <div data-testid={`experience-row-${i}`} className="grid gap-3 border-t border-[#1E2936] py-10 md:grid-cols-[200px_1fr] md:gap-12">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9AA6B2]">{r.dates}</p>
              <div>
                <h3 className="font-serif text-2xl leading-snug tracking-tight text-[#F6F5F2]">{r.role}</h3>
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#D18237]">{r.org}</p>
                <p className="mt-4 max-w-3xl text-sm leading-[1.9] text-[#9AA6B2] md:text-base">{r.body}</p>
              </div>
            </div>
          </FadeIn>
        ))}
        <FadeIn>
          <div data-testid="community-block" className="mt-6 border border-[#1E2936] bg-[#0E1520] p-8 md:p-12">
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D18237]">Community</p>
            <div className="mt-4 flex flex-col justify-between gap-2 md:flex-row md:items-baseline">
              <h3 className="font-serif text-2xl tracking-tight text-[#F6F5F2]">{EXPERIENCE.community.name}</h3>
              <p className="text-xs uppercase tracking-[0.18em] text-[#9AA6B2]">{EXPERIENCE.community.place} · {EXPERIENCE.community.dates}</p>
            </div>
            <p className="mt-4 max-w-3xl text-sm leading-[1.9] text-[#9AA6B2] md:text-base">{EXPERIENCE.community.body}</p>
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);
